import { render, staticRenderFns } from "./job_fair_import.vue?vue&type=template&id=398c0527&scoped=true"
import script from "./job_fair_import.vue?vue&type=script&lang=js"
export * from "./job_fair_import.vue?vue&type=script&lang=js"
import style0 from "./job_fair_import.vue?vue&type=style&index=0&id=398c0527&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c0527",
  null
  
)

export default component.exports